export default "__VITE_ASSET__d4f2ff15__"